<template>
    <div id="templatePane">
        <div class="hero-section shade-40">
            <div class="hero-section-text row column">
                <h1>Help!  Someone has changed my details!</h1>
            </div>
        </div>
        <section id="mainContent" class="row column">
            <h2>Act quickly - here's what to do</h2>
            <p>If your phone details have been changed and it wasn't you, it's important that you take swift action, as your work account may have been compromised.  Stay calm, and follow the following steps.</p>
            <div class="row" data-equalizer data-equalize-on="medium">
                <div class="medium-6 column">
                    <div class="callout" data-equalizer-watch>
                    <h3>If you have access to the intranet</h3>
                    <ol>
                        <li>Visit <a href="https://passwordchange.intra.bt.com/Home/PasswordPin" target="_blank">Password manager</a> and change your password.  There are a number of options on Password manager that you can try.</li>
                        <li>If none of the steps on the Password manager site work for you, please contact your service desk.</li>
                    </ol>
                    </div>
                </div>
                <div class="medium-6 column">
                    <div class="callout" data-equalizer-watch>
                    <h3>If you don't have access to the intranet</h3>
                    <ol>
                        <li>Try to <a href="https://authenticate.bt.com/adfs/portal/updatepassword/" target="_blank">change your password</a> to secure your account.</li>
                        <li>If that doesn't work, it may be that someone has changed your password.  Please contact your service desk to secure your account.</li>
                    </ol>
                    </div>
                </div>
            </div>

            <h3>What to do once your account is secure</h3>
            <ul>
                <li>Once your account is secure, you'll need to contact your service desk to reset your 'Multi Factor Authentication' phone details.</li>
                <li>If you think your account has been compromised and someone may have gained access to business information, don't bury your head in the sand, report a data breach to BT security.  If you're on the intranet you can <a href="https://intra.bt.com/bt/security/incident/Pages/index.aspx" target="_blank">raise an incident online</a>.  Contact your line manager if you need help doing this.</li>    
            </ul>        
        </section>
    </div>
</template>
<script>
export default {
    name: 'HelpSecurity',
    mounted() {
        // eslint-disable-next-line
        this.equalizer = new Foundation.Equalizer($('[data-equalizer]'))
    }
}
</script>